"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBeginPasswordResetBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateBeginPasswordResetBody = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
});
//# sourceMappingURL=BeginPasswordResetBody.js.map